// Go's database/sql Null* types marshal as {String:"x",Valid:true}; rendering such an
// object as a React child throws error #31. Collapse them to plain values / null.
const WRAPPERS = ['String', 'Int64', 'Int32', 'Int16', 'Float64', 'Bool', 'Time', 'Byte'];

export function unwrapGoNull(v) {
    if (Array.isArray(v)) return v.map(unwrapGoNull);
    if (v && typeof v === 'object') {
        const keys = Object.keys(v);
        if (keys.length === 2 && 'Valid' in v) {
            const k = WRAPPERS.find((w) => w in v);
            if (k) return v.Valid ? v[k] : null;
        }
        const out = {};
        for (const key of keys) out[key] = unwrapGoNull(v[key]);
        return out;
    }
    return v;
}
